import React from 'react';

function Layout({ children }) {
  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar bg-info">
        <div className="container-fluid">
          <a className="navbar-brand" href="/dashboard">
            <h1>🦏 Rhino</h1>
          </a>
          <h5>A high performance unicorn!</h5>
          <div className="collapse navbar-collapse ms-5" id="navbarNav">
            <ul className="navbar-nav">
              <li className="nav-item px-2">
                <a className="nav-link" href="/students">
                  Students
                </a>
              </li>
              <li className="nav-item px-2">
                <a className="nav-link" href="/trainers">
                  Trainers
                </a>
              </li>
              <li className="nav-item px-2">
                <a className="nav-link" href="/courses">
                  Courses
                </a>
              </li>
              <li className="nav-item px-2">
                <a className="nav-link" href="/resources">
                  Resources
                </a>
              </li>
              <li className="nav-item px-2">
                <a className="nav-link" href="/templates">
                  Templates
                </a>
              </li>
              <li className="nav-item px-2">
                <a className="nav-link" href="/chats">
                  Messages
                </a>
              </li>
              <li className="nav-item px-2">
                <a className="nav-link" href="/contacts">
                  Queries
                </a>
              </li>
              <li className="nav-item px-2">
                <a className="nav-link pointer" onClick={handleLogout}>
                  Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {children}
    </>
  );
}

export default Layout; 